import { APIids } from './config.types'

const ERS = {
  BASE_URL: 'https://gatewayers-qa.national.aaa.com',
  CONFIG_TEXT: 'Currently using the ERS (new) gateway',
  ID: 'ERS' as APIids,
}

export { ERS }
